import { baseUrl } from 'pages/Routes';
import { Helmet } from 'react-helmet';

export type OgProps = {
    type?: string;
    title?: string;
    description?: string;
    imageName: string;
    alt: string;
};

export type preloadProps = { as: 'image' | 'video' | 'font'; href: string };

export type HelmetProps = {
    title: string;
    description: string;
    relPath?: string;
    og?: OgProps;
    preloads?: preloadProps[];
};
const sortOrder = {
    font: 0,
    image: 1,
    video: 2,
};

export const HelmetHeader = (props: HelmetProps) => {
    const { title, description, relPath, og, preloads } = props;
    preloads?.sort((a, b) => {
        return sortOrder[a.as] - sortOrder[b.as];
    });
    const absolutePath = baseUrl + (relPath ?? '');
    return (
        <Helmet>
            <title>{title}</title>
            <meta
                name="title"
                content={title}
            />
            <meta
                name="description"
                content={description}
            />
            <link
                rel="canonical"
                href={absolutePath}
            />
            {preloads &&
                preloads.map((pl) => (
                    <link
                        key={pl.href}
                        rel="preload"
                        as={pl.as}
                        href={pl.href}
                        type={pl.as?.startsWith('font') ? 'font/woff2' : pl.as?.startsWith('video') ? 'video/webm' : undefined}
                        fetchPriority={pl.as?.startsWith('font') ? 'high' : 'auto'}
                    />
                ))}

            {relPath && (
                <meta
                    property="og:url"
                    content={absolutePath}
                />
            )}
            <meta
                property="og:locale"
                content="en_US"
            />
            {og && (
                <meta
                    property="og:type"
                    content={og.type ?? 'website'}
                />
            )}
            {og && (
                <meta
                    property="og:title"
                    content={og.title ?? title}
                />
            )}
            {og && (
                <meta
                    property="og:description"
                    content={og.description ?? description}
                />
            )}
            {og && (
                <meta
                    property="og:image"
                    content={baseUrl + '/images/' + og.imageName}
                />
            )}
            {og && (
                <meta
                    property="og:image:alt"
                    content={og.alt}
                />
            )}
        </Helmet>
    );
};
